import { render, staticRenderFns } from "./GroupRemitterEmailComponent.vue?vue&type=template&id=4b379f0c"
import script from "./GroupRemitterEmailComponent.vue?vue&type=script&lang=js"
export * from "./GroupRemitterEmailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports